import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { ctw } from '@/common/utils/ctw';

const labelVariants = cva('', {
  variants: {
    variant: {
      primary: 'text-primary',
      secondary: 'text-secondary',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

export type LabelVariantProps = VariantProps<typeof labelVariants>;

export type LabelProps = {
  text: string;
  className?: string;
} & LabelVariantProps;

export const Label = ({ text, className, variant }: LabelProps) => {
  return <span className={ctw(labelVariants({ variant }), className)}>{text}</span>;
};
